import { FormlyFieldConfig } from '@ngx-formly/core';
import { DetailsFormOptions } from './details-form-options.interface';

/**
 * SECTION 4.4: CO-APPLICANT BANKING INFORMATION
 */
export function getCoApplicantBankingFields(options: DetailsFormOptions): FormlyFieldConfig[] {
  return [
    // Banking
    {
      fieldGroupClassName: 'row',
      fieldGroup: [
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Co_Applicant_Financial_Institution_Name',
          type: 'input',
          props: {
            label: 'Financial Institution Name',
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Co_ApplicantFinancial_Institution_Number1',
          type: 'input',
          props: {
            label: 'Financial Institution Number',
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Co_Applicant_Bank_Account',
          type: 'input',
          props: {
            label: 'Bank Account Number',
          },
        },
        {
          className: 'col-sm-6 col-lg-4',
          key: 'Co_Applicant_Bank_Transit_No',
          type: 'input',
          props: {
            label: 'Bank Transit Number',
          },
        },
        {
          className: 'col-sm-8',
          key: 'Co_Applicant_Branch_Address',
          type: 'input',
          props: {
            label: 'Branch Address',
          },
        },
      ],
    },
  ];
}